import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=46d49634&scoped=true"
import script from "./LoginFooter.vue?vue&type=script&lang=ts"
export * from "./LoginFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d49634",
  null
  
)

export default component.exports